// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://hudpwbqdvkfdqaypymwz.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh1ZHB3YnFkdmtmZHFheXB5bXd6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDIxNTczMTYsImV4cCI6MjA1NzczMzMxNn0.cmp-qANtRCETtzb1W2tzV2UJsJ_EO-txaXHQMNplAjc";

// Ajouter les utilitaires pour les cookies
function getCookie(name: string): string | null {
  if (typeof window === 'undefined') return null;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift() || null;
  return null;
}

function setCookie(name: string, value: string, options: {
  domain?: string;
  maxAge?: number;
  sameSite?: 'strict' | 'lax' | 'none';
  secure?: boolean;
}) {
  if (typeof window === 'undefined') return;
  
  let cookieString = `${name}=${value}`;
  
  if (options.domain) cookieString += `; domain=${options.domain}`;
  if (options.maxAge) cookieString += `; max-age=${options.maxAge}`;
  if (options.sameSite) cookieString += `; samesite=${options.sameSite}`;
  if (options.secure) cookieString += `; secure`;
  cookieString += `; path=/`;
  
  document.cookie = cookieString;
}

function removeCookie(name: string, options: { domain?: string }) {
  if (typeof window === 'undefined') return;
  
  let cookieString = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/`;
  if (options.domain) cookieString += `; domain=${options.domain}`;
  document.cookie = cookieString;
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: {
      isServer: false,
      getItem: (key: string) => {
        if (typeof window === 'undefined') return null;
        
        // D'abord essayer localStorage (fallback pour compatibilité)
        const localItem = localStorage.getItem(key);
        if (localItem) {
          console.log('Found auth data in localStorage:', key);
          return localItem;
        }
        
        // Ensuite essayer les cookies
        const cookieItem = getCookie(key);
        if (cookieItem) {
          console.log('Found auth data in cookies:', key);
          return cookieItem;
        }
        
        console.log('No auth data found for:', key);
        return null;
      },
      setItem: (key: string, value: string) => {
        if (typeof window === 'undefined') return;
        
        console.log('Storing auth data:', key);
        
        // Stocker dans localStorage ET dans les cookies pour la compatibilité
        localStorage.setItem(key, value);
        
        setCookie(key, value, {
          domain: window.location.hostname.includes('recut.art') ? '.recut.art' : undefined,
          maxAge: 60 * 60 * 24 * 7, // 7 jours
          sameSite: 'lax',
          secure: window.location.protocol === 'https:'
        });
      },
      removeItem: (key: string) => {
        if (typeof window === 'undefined') return;
        
        console.log('Removing auth data:', key);
        
        // Supprimer de localStorage ET des cookies
        localStorage.removeItem(key);
        
        removeCookie(key, { 
          domain: window.location.hostname.includes('recut.art') ? '.recut.art' : undefined 
        });
      }
    },
    autoRefreshToken: true,
    persistSession: true
  }
});